import { ADD_VIEW_BATCHES, SET_STATUS_CARD_INDEX } from "./status_card_view/actions";

const initialState = {
  view_batches: null,
  status_card_index: -1,
};
export default function(state = initialState, action) {
  switch (action.type) {
    case ADD_VIEW_BATCHES:
      return Object.assign({}, state, {
        view_batches: action.payload
      });
    case SET_STATUS_CARD_INDEX:
      return Object.assign({}, state, {
        status_card_index: action.payload
      });

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/batch_status/Reducer.Claim_Status.js